import React from 'react';
import { AgentLayout as Layout, ListResources } from '../../components/Portal';
import MainContent from './PortalHome';


export default () => {
  const materials = [
    {
      redirect: 'https://www.dropbox.com/sh/oc0kfiwyqwjlwq5/AACoqFwrc6M-hzKCXrswSOuva?dl=0',
      title: 'Approved Agent HQ',
      description: 'Useful marketing assets like brochures, PDF\'s, social post examples to share with your client prospects.',
      imageUrl: '/images/portal/img-hq.jpg'
    },
    {
      redirect: 'https://vimeo.com/showcase/8305190',
      title: 'Kai-Zen Approved Video Showcase',
      description: 'Marketing videos for Kai-Zen you can share with your clients to help them understand the strategy benefits.',
      imageUrl: '/images/portal/img-video-showcase.jpg'
    },
    {
      redirect: 'https://vimeo.com/showcase/9774023',
      title: 'Kai-Zen Approved Testimonials',
      description: 'Real client testimonials for Kai-Zen.',
      imageUrl: '/images/portal/img-testimonials.jpg'
    },
    {
      redirect: 'https://vimeo.com/showcase/9664533',
      title: 'Weekly Webinars',
      description: 'Useful recordings of webinars with clients so you can better understand their needs and concerns.',
      imageUrl: '/images/portal/img-webinars.jpg'
    }
  ];
  return (
    <Layout>
      <MainContent title="Marketing Material" description="Select an option below to view useful marketing materials.">
        <ListResources resources={materials} />
      </MainContent>
    </Layout>
  )
};
